import { useState, useEffect } from "react";
import { Button, Modal, Spin } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import { connect } from "react-redux";

import { Modals } from "scripts/settings";
import Resources from "scripts/resources";
import { GetUrlParams, ObjectToURL } from "scripts/helpers";

const MapEvent = ({ onChange }) => {
	const map = useMap();

	map.on("moveend", () => {
		const { lat, lng } = map.getCenter();

		onChange({ latitude: lat, longitude: lng, zoom: map.getZoom() });
	});

	return null;
};

const Component = ({}) => {
	const initialState = {
		_coords: {
			latitude: process.env.REACT_APP_LATITUDE,
			longitude: process.env.REACT_APP_LONGITUDE,
		},
	};
	const [state, setState] = useState(initialState);
	const { _coords, loading, visible } = state;
	const location = useLocation();
	const { category, search, sortBy } = GetUrlParams(location.search);
	const navigate = useNavigate();
	const coordinatesQuery = ObjectToURL({ category, search, sortBy });

	const handleChange = ({ latitude, longitude }) => {
		setState((prevState) => ({
			...prevState,
			_coords: {
				latitude: latitude.toString(),
				longitude: longitude.toString(),
			},
		}));
	};

	const handleSubmit = () => {
		navigate(
			`/jobs?${coordinatesQuery && `${coordinatesQuery}&`}coordinates=${
				_coords.latitude
			},${_coords.longitude}`
		);
	};

	const componentDidUpdate = () => {
		if (location?.hash?.startsWith(`#${Modals.AROUND}`)) {
			setState((prevState) => ({
				...prevState,
				visible: true,
				loading: true,
			}));

			setTimeout(() => {
				setState((prevState) => ({
					...prevState,
					loading: false,
				}));
			}, 2000);
		} else {
			setState(initialState);
		}
	};

	useEffect(componentDidUpdate, [location.hash]);

	return (
		<Modal
			className="bk-modal-around"
			footer={
				<>
					<Button type="primary" onClick={handleSubmit}>
						{Resources.confirm}
					</Button>
					<Button onClick={() => navigate(-1)}>{Resources.cancel}</Button>
				</>
			}
			maskClosable={false}
			onCancel={() => navigate(-1)}
			open={visible}
			width={500}
			destroyOnClose
			title={Resources.chooseLocation}
		>
			{loading ? (
				<Spin className="page-loading" />
			) : (
				<MapContainer
					center={{
						lat: parseFloat(process.env.REACT_APP_LATITUDE),
						lng: parseFloat(process.env.REACT_APP_LONGITUDE),
					}}
					length={4}
					zoom={parseInt(process.env.REACT_APP_ZOOM)}
					style={{ height: 220, width: "100%" }}
				>
					<MapEvent onChange={handleChange} />
					<TileLayer
						attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
						url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
					/>
				</MapContainer>
			)}
		</Modal>
	);
};

export default connect((state) => {
	return {
		categories: state.categories,
	};
})(Component);
